import styled from 'styled-components'
import { SPACING, TYPOGRAPHY, TRANSITIONS, FONT_WEIGHT } from '../../styles/theme'

const MIN_METHOD_PANEL_WIDTH = '340px'
const HEADER_HEIGHT = '64px'

export const PageLayout = styled.div`
  display: flex;
  height: calc(100dvh - ${HEADER_HEIGHT});
`

export const ReportPanel = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 ${SPACING.xl} ${SPACING.xl};
  max-width: 900px;
`

export const ReportPanelHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: ${SPACING.xxl};
  padding: ${SPACING.md} 0;
  background: var(--color-bg-primary);
  box-shadow: 0 1px 0 var(--color-border, #e8e8e8);
`

export const SelectionBannerWrapper = styled.div`
  margin: 0 -${SPACING.xl};
  margin-bottom: ${SPACING.lg};
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 4px 0;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  line-height: 1;
  transition: color ${TRANSITIONS.fast};

  &:hover {
    color: var(--color-text-primary);
  }
`

export const PageTitle = styled.h2`
  font-size: ${TYPOGRAPHY.h4.fontSize};
  font-weight: ${FONT_WEIGHT.bold};
  color: var(--color-text-primary);
  margin: 0;
`

export const MethodPanel = styled.div`
  flex: 1;
  min-width: ${MIN_METHOD_PANEL_WIDTH};
  height: 100%;
  border-left: 1px solid var(--color-border);
  padding: ${SPACING.xl};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-sizing: border-box;
`

export const MethodPanelTitle = styled.h3`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  margin: 0 0 ${SPACING.xs} 0;
`

export const MethodPanelSubtitle = styled.p`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: ${TYPOGRAPHY.caption.lineHeight};
  color: var(--color-text-tertiary);
  margin: 0 0 ${SPACING.xl} 0;
`

export const MethodsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs};
`

export const MethodContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${SPACING.sm};
  padding-top: ${SPACING.xl};
  border-top: 1px solid var(--color-border);
  margin-top: auto;
`

export const EmptyReport = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.md};
  padding: ${SPACING.xxxl} 0;
  color: var(--color-text-tertiary);
  font-size: ${TYPOGRAPHY.body.fontSize};
`
